import { Deserializable } from '../protocols/deserializable';
import { SubmissionAttachment } from './submission-attachment';

export class SubmissionCreated implements Deserializable {
  public id: number = -1;
  public memberId: number = -1;
  public submissionTypeId: number = -1;
  public submissionTypeName: string = '';
  public statusId: number = -1;
  public status: string = '';
  public idPrefix: string = '';
  public idSuffix: string = '';
  public createdDate: string | null = null;
  public completedDate: string | null = null;
  public expiringSoon: boolean = false;
  public comment: string = '';
  public attachments: SubmissionAttachment[] = [];

  onDeserialize() {
    if (!!this.attachments) {
      this.attachments = window.injector.Deserialize.arrayOf(SubmissionAttachment, this.attachments);
    }
  }
}
